import { v4 as uuidv4 } from 'uuid'

// A unique id for this browser tab / page load. Used to distinguish concurrent sessions of the
// same user (the same account open in two tabs, or shared across devices) — so HI presence can
// show your own marker only when another session of your account also has the patient open.
export const TAB_SESSION_ID = uuidv4()
